import {CreditCardInfo, CreditCardInfoJSON} from './BucketMemberInfoDTO'
import {ADDRESS, GENDER} from '../../../../Common/Constants'
import {Nullable} from '../../../../Common/TypeHelper'
import {MembersBelongToBucket, MembersBelongToBucketDTO, MembersBelongToBucketJSON} from "./MembersBelongToBucketDTO";

export type MemberJSON = {
  id: number,
  mail: string,
  familyName: string,
  familyNameKana: string,
  firstName: string,
  firstNameKana: string,
  gender: Nullable<number>,
  birthday: Nullable<string>,
  phoneMobile: string,
  phoneTel: string,
  postCode: string,
  addressPrefectureCode: string,
  addressCity: string,
  addressStreet: string,
  addressBuilding: string,
}

export type MemberInfoJSON = {
  member: MemberJSON
  creditCardInfoList: CreditCardInfoJSON[]
  bucketList: MembersBelongToBucketJSON[]
  accountCreationDatetime: string
}

export type Member = Omit<MemberJSON,
  'gender'> & {
  createdAt: string
  gender: string
  genderCode: string
  addressPrefecture: string
}

export interface MemberInfo {
  member: Member
  creditCardInfoList: CreditCardInfo[]
  bucketList: MembersBelongToBucket[]
}

export class MemberInfoDTO implements MemberInfo {
  member: Member
  creditCardInfoList: CreditCardInfo[]
  bucketList: MembersBelongToBucket[]

  constructor(
    member: Member,
    creditCardInfoList: CreditCardInfo[],
    bucketList: MembersBelongToBucket[]
  ) {
    this.member = member
    this.creditCardInfoList = creditCardInfoList
    this.bucketList = bucketList
  }

  static fromJSON(jsonObject: MemberInfoJSON): MemberInfoDTO {
    const {member, creditCardInfoList, bucketList} = jsonObject
    const {gender, birthday, addressPrefectureCode, ...rest} = member

    return new MemberInfoDTO(
      {
        ...rest,
        createdAt: jsonObject.accountCreationDatetime,
        gender: gender ? GENDER[gender] : '',
        genderCode: gender ? String(gender) : '',
        birthday: birthday ?? '',
        addressPrefecture: addressPrefectureCode ? ADDRESS.PREFECTURES[addressPrefectureCode] : '',
        addressPrefectureCode: addressPrefectureCode,
      },
      creditCardInfoList,
      bucketList.map(b => MembersBelongToBucketDTO.fromJSON(b)),
    )
  }
}
